import React, { createContext, useContext, useState, useEffect } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getProgressBoxConfig } from '../progressbox/config';
import { getPostingLastStep } from '../../ducks/stepper';

const StepperContext = createContext();

const useStepperCtx = () => useContext(StepperContext);

const stepsConfig = Object.freeze({
  1: {
    id: 1,
    enabledStep: { step: '1', module: '0' },
    title: 'publisher.stepper.1',
    path: '/publicador/principales'
  },
  2: {
    id: 2,
    enabledStep: { step: '1', module: '3' },
    title: 'publisher.stepper.2',
    path: '/publicador/multimedia'
  },
  3: {
    id: 3,
    enabledStep: { step: '2', module: '1' },
    title: 'publisher.stepper.3',
    path: '/publicador/extras'
  },
  4: {
    id: 4,
    enabledStep: { step: '3', module: '1' },
    title: 'publisher.stepper.4',
    path: '/publicador/planes'
  }
});

const StepperProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState('1');
  const [currentModule, setCurrentModule] = useState('operacionypropiedad');
  const [preventTransition, setPreventTransition] = useState(false);
  const [nextStepperRoute, setNextStepperRoute] = useState(null);
  const [stepperFormRef, setStepperFormRef] = useState(null);
  const { params } = useRouteMatch('/publicador/:step?/:module?');
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const postId = new URLSearchParams(location.search).get('postingId');
    if (postId) dispatch(getPostingLastStep(postId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Object.values(stepsConfig).forEach(({ id, path }) => {
      if (params.step && path.endsWith(params.step)) {
        if (
          !location.pathname.includes('principales/operacionypropiedad') &&
          !new URLSearchParams(location.search).get('postingId')
        ) {
          window.location.href = '/panel/publicador/principales/operacionypropiedad';
        }
        setCurrentStep(id);
      }
    });

    if (params.module && params.module !== currentModule) {
      setCurrentModule(params.module);
    }
  }, [params, setCurrentStep, setCurrentModule, currentModule, location.pathname, location.search, history]);

  const configPreventTransition = ref => {
    setPreventTransition(!!ref);
    setStepperFormRef(ref);
  };

  return (
    <StepperContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        currentModule,
        currentModuleConfig: getProgressBoxConfig(currentStep),
        moduleName: params.module,
        preventTransition,
        setPreventTransition: configPreventTransition,
        nextStepperRoute,
        setNextStepperRoute,
        stepperFormRef,
        setStepperFormRef
      }}
    >
      {children}
    </StepperContext.Provider>
  );
};

export { useStepperCtx, StepperProvider, stepsConfig };
